// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__32zmE","select":"Header_select__2BeOl","clinic":"Header_clinic__3JqXx"};